module.exports = __webpack_public_path__ + "static/media/ProfessionalRoadmap.29e59971.svg";